function getNewsPopupHtml(news) {
	return `
		<div class="popup-article">
			<div class="article-title">&gt;&gt;&nbsp;${news.title}
				<div class="article-time">POST TIME - [ ${news.create_time} ]&nbsp;&lt;&lt;</div>
			</div>
			<div class="article-content">
				${news.content}
			</div>
		</div>`;
}

export default getNewsPopupHtml


// WEBPACK FOOTER //
// ./src/components/NewsGenerator.js